'use strict';

module.exports = {
    IP_GEOLOCATION: 'IP_GEOLOCATION',
    MANAGERS_AND_AGENTS_STATUS_EVENT: 'MANAGERS_AND_AGENTS_STATUS_EVENT',
    MANUAL_OVERRIDE: 'MANUAL_OVERRIDE'
};